exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".topic-container .topic-content-container {\n  display: flex; }\n  .topic-container .topic-content-container .topic-articles {\n    flex-grow: 3; }\n", ""]);

// exports
